import type { EditorAction, EditorState } from "../../editor/reducers";
import type { Dispatch } from "react";
import {
  useTableRegionCreationTabSuspenseQuery,
  type TableRegionCreationTabFragment,
} from "../../client/generated";
import { ScrollArea } from "@acdc2/ui/components/scroll-area";
import { NavbarTabCloseButton } from "../../shell/NavbarTabCloseButton";
import { NavbarTabContent } from "../../shell/NavbarTabContent";
import { useTranslation } from "react-i18next";
import { makeTabIdentifier } from "../../editor/reducers";
import { TableRegionUpsertForm } from "./TableRegionUpsertForm";
import { assertTypeName } from "../../client/guards";

type Props = {
  fragment: TableRegionCreationTabFragment;
  state: EditorState;
  dispatch: Dispatch<EditorAction>;
};

export function TableRegionCreationTab({ fragment, state, dispatch }: Props) {
  const { t } = useTranslation();

  return (
    <NavbarTabContent
      value={makeTabIdentifier("table", fragment.id)}
      title={t("TableRegionCreationTab.title")}
      right={<NavbarTabCloseButton dispatch={dispatch} />}
    >
      <ScrollArea className="flex-1">
        <Body fragment={fragment} state={state} dispatch={dispatch} />
      </ScrollArea>
    </NavbarTabContent>
  );
}

function Body({ fragment, state, dispatch }: Props) {
  const { data } = useTableRegionCreationTabSuspenseQuery({
    variables: {
      regionId: fragment.id,
    },
  });

  assertTypeName(data.region?.__typename === "Region");

  return (
    <TableRegionUpsertForm
      fragment={data.region}
      state={state}
      dispatch={dispatch}
    />
  );
}
